var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 80,
    viewBox: "0 0 88 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.542969,
    width: 87.2699,
    height: 80,
    rx: 4,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1697 25.7773C40.992 25.7808 37.9454 26.9593 35.6984 29.0542C33.4514 31.1491 32.1874 33.9893 32.1836 36.9519C32.1798 39.373 33.0281 41.7284 34.5983 43.6567C34.5983 43.6567 34.9252 44.058 34.9786 44.1159L44.1697 54.2218L53.3653 44.1108C53.4132 44.057 53.7412 43.6567 53.7412 43.6567L53.7423 43.6537C55.3117 41.7262 56.1596 39.3719 56.1559 36.9519C56.1521 33.9893 54.8881 31.1491 52.6411 29.0542C50.394 26.9593 47.3475 25.7808 44.1697 25.7773ZM44.1697 41.0154C43.3077 41.0154 42.465 40.7771 41.7482 40.3306C41.0315 39.8841 40.4728 39.2495 40.1429 38.507C39.813 37.7645 39.7267 36.9474 39.8949 36.1592C40.0631 35.371 40.4782 34.6469 41.0877 34.0786C41.6973 33.5103 42.4739 33.1233 43.3194 32.9665C44.1649 32.8097 45.0413 32.8902 45.8377 33.1978C46.6341 33.5053 47.3148 34.0262 47.7938 34.6944C48.2727 35.3626 48.5283 36.1483 48.5283 36.9519C48.5269 38.0292 48.0672 39.062 47.2501 39.8238C46.4331 40.5855 45.3253 41.0141 44.1697 41.0154Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationImg);
export default __webpack_public_path__ + "static/media/location-img.ef1cc76cd85b520dd4ab57212a63651a.svg";
export { ForwardRef as ReactComponent };